import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { ReviewsReportPage } from '@/features/reports/reviews/reviews-report-page'
import { formatDocumentTitle } from '@/lib/document-title'

/** Reports › Reviews & Google at `/$orgId/reports/reviews`: the reports grant together with a Campaigns grant. */
export const Route = createFileRoute('/_auth/$orgId/reports/reviews')({
  component: ReviewsRoute,
})

function ReviewsRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Reviews & Google')}</title>
      </Helmet>
      <ReviewsReportPage />
    </>
  )
}
